// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as GemModelExtended } from '../../../../../ui-v3/src/assets/icons/extended/entities/gem-model.svg?react';
import { createIcons } from '../../Icon';
const GemModelIcon = /* @__PURE__ */ createIcons('GemModel', {
    extended: GemModelExtended
});
GemModelIcon.supportedTypes = [
    'extended'
];
GemModelIcon.category = 'entities';
export default GemModelIcon;
